import { useState, useCallback } from 'react';
import { useNegotiateCommercialOfferMutation } from 'api';

export const useNegotiateOffer = (
  negotiateForm: any,
  handleSuccess: (message: string) => void,
  handleError: (error: any) => void
) => {
  const [offerToNegotiate, setOfferToNegotiate] = useState<string | undefined>();
  const [negotiateOffer, { isLoading: isLoadingNegotiate }] = useNegotiateCommercialOfferMutation();

  const closeModal = useCallback(() => {
    setOfferToNegotiate(undefined);
    negotiateForm.resetFields();
  }, [negotiateForm]);

  const handleNegotiate = useCallback(async () => {
    try {
      const values = await negotiateForm.validateFields();

      const result = await negotiateOffer({
        id: offerToNegotiate,
        negotiatePhase: values.negotiatePhase,
        negotiateInformation: values.negotiateInformation,
      });

      if ('error' in result) {
        handleError('Failed to negotiate deal');
        return;
      }

      handleSuccess('Commercial Offer was successfully negotiated.');
      closeModal();
    } catch (error) {
      console.error('Validation failed:', error);
    }
  }, [negotiateForm, negotiateOffer, offerToNegotiate, closeModal, handleSuccess, handleError]);

  return {
    offerToNegotiate,
    setOfferToNegotiate,
    isLoadingNegotiate,
    handleNegotiate,
    closeModal,
  };
};
